<template>
  <div>
     
    <div
      :class="{'attivo' : dropDownOpened}" :style="[dropDownOpened ? {'background-color' : _.get(active, 'color', 'grey')} : {'color': 'white'}]"
      class="cerchio d-flex align-items-center justify-content-center"
    >
  
      <i @click="dropDownOpened=true" class="tag fas fa-tag" :style="{'color' : _.get(active, 'color', '#e6e6e6')}"></i>
    </div>
    <div v-if="dropDownOpened" class="ilmenu fade-in-top">
       <a class="dropdown-item" href="#" @click="listinoChangeHandler(undefined)">
        <i class="fas fa-tag" style="color:grey;"></i> &nbsp; &nbsp;
        <span :class="{'grassetto' : active === undefined}">Standard</span>
      </a>

      <a v-for="(listino, index) in listini" :key="index" class="dropdown-item" href="#" @click="listinoChangeHandler(listino.id)">
        <i class="fas fa-tag" :style="{'color' : listino.color}"></i> &nbsp; &nbsp;
           <span :class="{'grassetto' : active && active.id === listino.id}">{{listino.titolo}}</span>
      </a>
     
      
    </div>
    <div v-if="dropDownOpened" @click="outSideClick()" class="outSideClickCapture"></div>
    <!--<span>Listino</span>
    <select v-model="orderObj.list" @change="listinoChangeHandler($event)">
      <option value="undefined">Nessun listino</option>
      <option
        :name="listino.titolo"
        :value="listino.id"
        v-for="listino in listini"
        :key="listino.id"
      >{{ listino.titolo }}</option>
    </select>
    -->
     <span style="font-size:0.7vw; color:#d4d4d4;">{{ _.get(active, 'titolo', 'Listino') }}</span>
  </div>
</template>

<script>
import Vue from "vue";
import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "listinoSelector",
  props: ["idActiveList"],
  data() {
    return {
      expired: false,
      message: "Caricando...",
      dropDownOpened: false
      //VARIABILI AMBIENTE
    };
  },
  computed: {
    ...mapGetters({
      orderObj: "ordineStates/orderObj",
      listini: "listinoStates/listini",
      active: "listinoStates/active"
    })
  },
  methods: {
    outSideClick() {
      this.dropDownOpened = null;
    },
    listinoChangeHandler(id) {
      this.dropDownOpened = false
      this.$store.commit("listinoStates/changed");
      this.$store.commit("listinoStates/setActive", id);
      this.$store.commit("ordineStates/setOrderObj", {
        key: "list",
        value: id
      });
    }
  },
  mounted() {
    var self = this;
    this.$store
      .dispatch("listinoStates/get", {
        source: "listini",
        idActiveList: self.idActiveList
      })
      .then(response => {
        console.log(
          "Listini caricati e  settato attivo : " + self.idActiveList
        );
      })
      .catch(err => {
        console.log(err);
      });
  },
  watch: {}
};
</script>

<style scoped>
.grassetto{
  font-weight: bold !important;
}
.cerchio {
  margin: 0 auto;
  height: 2vw;
  width: 2vw;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-transition: all 200ms ease-out;
  -moz-transition: all 200ms ease-out;
  -o-transition: all 200ms ease-out;
  transition: all 200ms ease-out;
  
  
}

.attivo {
  -webkit-transition: all 200ms ease-out;
  -moz-transition: all 200ms ease-out;
  -o-transition: all 200ms ease-out;
  transition: all 200ms ease-out;



}

.attivo i {
  color:white !important;
  font-size: 1vw;
  line-height: 1vw;
}

.tag {
  margin-top: 0.3vh;
  
  font-size: 1.5vw;
  line-height: 1.5vw;
  -webkit-transition: all 200ms ease-out;
  -moz-transition: all 200ms ease-out;
  -o-transition: all 200ms ease-out;
  transition: all 200ms ease-out;
}

div {
  text-align: center;
}
img {
  width: 50px;
  height: 50px;
}
.ilmenu {
  background-color: white;
  z-index: 99999 !important;
  position: fixed;
  margin-top: 10px;
  -webkit-box-shadow: 0px 0px 18px -8px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 18px -8px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 18px -8px rgba(0, 0, 0, 0.75);
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;
  padding: 0.5vw;
  text-align: left;
}

.dropdown > i {
  background-color: #949595;
  color: white;
  outline: none !important;
  border-radius: 50%;
  height: 2vh;
  width: 2vh;
  text-align: center;
  line-height: 2.3vh;
  font-size: 1em;
}

.dropdown-item {
  color: #636363;
  font-size: 1.9vh;
}

.dropdown button:hover {
  background-color: #6c757d;
}

.dropdown button:focus {
  outline: none !important;
}

.fade-in-top {
  -webkit-animation: fade-in-top 0.2s both;
  animation: fade-in-top 0.2s both;
}

@-webkit-keyframes fade-in-top {
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fade-in-top {
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

.outSideClickCapture {
  position: fixed;
  height: 100%;
  width: 100%;
  background: none;
  top: 0px;
  left: 0px;
  opacity: 0.5;
  z-index: 9998;
}
</style>
